import { forwardRef as m } from "react";
import { useThemeUI as p, Text as f } from "theme-ui";
import { Skeleton as d } from "../Skeleton/Skeleton.js";
import { jsx as r } from "theme-ui/jsx-runtime";
const h = m((i, s) => {
  const {
    variant: o = "body",
    ellipsis: e,
    inherit: l,
    loading: n = !1,
    skeletonSx: x,
    ...a
  } = i, {
    theme: t
  } = p();
  return /* @__PURE__ */ r(d, {
    variant: "text",
    enabled: n,
    asChild: !0,
    sx: x,
    children: /* @__PURE__ */ r(f, {
      ref: s,
      variant: o,
      ...a,
      sx: {
        ...e === !0 && t.textEllipsis,
        ...typeof e == "number" && t.textEllipsisMultiline(e),
        ...l && t.textInherit,
        ...i.sx
      }
    })
  });
});
h.displayName = "Text";
export {
  h as Text
};
